import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { master } from '../../assets/main';
import { Wrapper } from './style';
import Layout from '../Layout';

class LevelControl extends PureComponent {
  render() {
    const { levelsObject } = master;
    const { points } = this.props;

    return (
      <Layout points={points}>
        <Wrapper>
          {levelsObject.map((inner, levelsIndex) => {
            const theLevel = levelsIndex + 1;
            return (
              <div key={levelsIndex} className="level-wrapper">
                <h3>Level {theLevel}</h3>
                <div className="flex">
                  {inner.map((_, theAudioGame) => {
                    const theGame = theAudioGame + 1;
                    return (
                      <Link key={theAudioGame} to={`/level/${theLevel}/${theGame}`} className="link-wrapper">
                        Game {theGame}
                      </Link>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </Wrapper>
      </Layout>
    );
  }
}

export default LevelControl;
